import { on } from '@ngrx/store';
import { AsyncActions } from './item-groupings.actions';
import { ManagementBaseActions } from '../base/management-base.actions';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const itemGroupingsFeatureKey = 'itemGroupings';

export interface ItemGroupingsState extends AsyncActionState {}

const initialState: ItemGroupingsState = {
    ...asyncActionState.initial
};

export const itemGroupingsReducer = withLoadables<ItemGroupingsState>({ ...AsyncActions })(
    initialState,
    on(ManagementBaseActions.initItemGroupings, () => ({
        ...initialState
    }))
);
